export function genCharArray(charA, charZ, uc: false) {
    const a = [];
    let i = charA.charCodeAt(0),
        j = charZ.charCodeAt(0);

    for (; i <= j; ++i) {
        if (uc) {
            a.push(String.fromCharCode(i).toUpperCase());
        } else {
            a.push(String.fromCharCode(i))
        }
    }

    return a;
}

export function setSpacing(char, charType) {
    let spacing,
        array;

    if (charType === 'lc') {
        array = [
            ["'", 72, 4, 12, 24], ['a', 46, 51, 52, 44], ['b', 48, 7, 50, 87], ['c', 67, 50, 34, 44], ['d', 46, 7, 52, 87], ['e', 71, 50, 31, 45], ['f', 43, 8, 55, 130], ['g', 48, 50, 49, 87],
            ['h', 46, 7, 53, 87], ['i', 78, 34, 26, 60], ['j', 44, 34, 52, 103], ['k', 42, 7, 55, 87], ['l', 77, 7, 26, 87], ['m', 30, 50, 88, 44], ['n', 33, 50, 62, 44],
            ['o', 48, 50, 51, 45], ['p', 34, 51, 62, 87], ['q', 58, 50, 41, 87], ['r', 46, 49, 52, 45], ['s', 68, 50, 33, 45], ['t', 68, 34, 33, 60], ['u', 47, 51, 52, 43],
            ['v', 49, 49, 50, 45], ['w', 46, 49, 78, 45], ['x', 32, 50, 61, 45], ['y', 47, 51, 49, 87], ['z', 61, 51, 39, 86]
        ];
    } else if (charType === 'uc') {
        array = [
            ['A', 58, 8, 78, 87], ['B', 82, 6, 58, 88], ['C', 74, 8, 64, 86], ['D', 60, 7, 75, 88], ['E', 82, 8, 58, 86], ['F', 82, 8, 58, 86], ['G', 67, 8, 70, 86],
            ['H', 47, 8, 86, 86], ['I', 128, 7, 22, 86], ['J', 72, 8, 66, 86], ['K', 56, 7, 79, 87], ['L', 100, 8, 44, 86], ['M', 64, 7, 105, 87], ['N', 42, 7, 89, 87],
            ['O', 67, 8, 71, 86], ['P', 76, 7, 63, 87], ['Q', 66, 8, 71, 90], ['R', 78, 7, 62, 87], ['S', 82, 7, 58, 87], ['T', 74, 8, 65, 86], ['U', 58, 7, 78, 87],
            ['V', 60, 7, 77, 87], ['W', 38, 7, 125, 87], ['X', 54, 7, 80, 87], ['Y', 58, 7, 78, 87], ['Z', 56, 7, 79, 86]
        ];
    } else if (charType === 'num') {
        array = [
            ['1', 90, 8, 16, 87], ['2', 58, 8, 44, 86], ['3', 61, 8, 40, 87], ['4', 58, 8, 41, 87], ['5', 60, 8, 40, 86], 
            ['6', 67, 8, 35, 86], ['7', 65, 8, 37, 87], ['8', 55, 8, 46, 86], ['9', 70, 8, 31, 86], ['10', 48, 8, 79, 87]
        ];
    }

    for (let i = 0; i < array.length; i++) {
        if (char === array[i][0]) {
            spacing = array[i];
            break;
        }
    }

    return spacing;
}

export function setOwnSpacing(char, charType) {
    let spacing,
        array;

    if (charType === 'lc') {
        array = [
            ['a', 51.95], ['b', 50], ['c', 33.55], ['d', 51.95], ['e', 30.8], ['f', 55.25], ['g', 48.9],
            ['h', 53.1], ['i', 25.6], ['j', 52.4], ['k', 54.8], ['l', 25.6], ['m', 87.7], ['n', 62.35],
            ['o', 50.55], ['p', 62.3], ['q', 41.15], ['r', 52.45], ['s', 32.75], ['t', 32.75], ['u', 51.55],
            ['v', 50], ['w', 78.05], ['x', 61.4], ['y', 48.9], ['z', 39.45], ['space', 29.85]
        ];
    } else if (charType === 'uc') {
        array = [
            ['A', 77.85], ['B', 58.05], ['C', 64.4], ['D', 74.8], ['E', 57.7], ['F', 57.55], ['G', 69.9],
            ['H', 85.55], ['I', 21.7], ['J', 65.5], ['K', 78.55], ['L', 43.8], ['M', 104.8], ['N', 89.05],
            ['O', 70.5], ['P', 63.45], ['Q', 70.5], ['R', 62.05], ['S', 58], ['T', 64.9], ['U', 78.15],
            ['V', 77.45], ['W', 125.25], ['X', 79.9], ['Y', 77.7], ['Z', 78.75], ['space', 29.85]
        ];
    }

    for (let i = 0; i < array.length; i++) {
        if (char === array[i][0]) {
            spacing = array[i];
            break;
        }
    }

    return spacing;
}

export function setWordBounds(word) {
    let spacing,
        array;

    array = [
                ['after', 238.75, [3.25, 59.35, 112.15, 151.7, 189.6]], 
                ['am', 146.65, [3.3, 62.25]], 
                ['and', 182.55, [3.3, 62.25, 133.9]], 
                ['are', 147.45, [3.35, 62.3, 120]], 
                ['at', 87.85, [3.35, 58.45]], 
                ['ate', 122.5, [3.25, 58.4, 94.95]], 
                ['because', 306.95, [3.35, 52.8, 90.1, 129.4, 187.65, 242.15, 279.5]], 
                ['big', 126.75, [3.3, 57.9, 81.15]],
                ['birthday', 398.5, [3.3, 54.9, 87.7, 143.75, 183.2, 243.6, 302.85, 352.9]], 
                ['bought', 292.55, [3.35, 52.85, 104.75, 152.85, 206.8, 263.15]], 
                ['brother', 351.9, [3.35, 59.15, 110.85, 165.55, 205, 264.9, 302.8]], 
                ['but', 139.6, [3.35, 55.4, 110.2]],
                ['called', 253.9, [3.25, 42.6, 102.3, 135.7, 168.1, 205.2]], 
                ['came', 218.6, [3.25, 42.6, 96.55, 191.05]], 
                ['can', 148.65, [3.35, 40.65, 89.65]],
                ['car', 139.8, [3.3, 41.65, 90.65]], 
                ['cat', 127.2, [8.5, 47.8, 102.95]], 
                ['could', 235.95, [3.25, 43.15, 94.95, 154.35, 187.25]], 
                ['dad', 170.35, [3.3, 62.5, 121.7]], 
                ['day', 158.1, [3.3, 62.45, 112.5]], 
                ['did', 144.7, [3.3, 63.1, 96.05]], 
                ['didnt', 274.35, [7.3, 67.1, 100.05, 159.05, 223.75, 248.9]], 
                ['do', 107.3, [3.25, 60]], 
                ['dog', 139.7, [3.25, 59.95, 94.05]], 
                ['each', 187.3, [3.3, 41.4, 98.75, 137.5]], 
                ['eat', 126, [3.3, 41.4, 96.55]],
                ['ever', 182.1, [3.3, 42.55, 95.05, 132.95]], 
                ['every', 223.6, [3.3, 42.55, 95.05, 132.95, 178]],
                ['everyone', 377.25, [3.3, 42.55, 95.05, 132.95, 178, 235.1, 283.6, 349.75]], 
                ['exit', 169.75, [3.3, 39.2, 108.4, 140.3], true], 
                ['fish', 176.3, [3.25, 57.7, 86.25, 126.45]], 
                ['fix', 144.6, [3.25, 55.7, 86.45], true], 
                ['football', 366.3, [3.25, 54.65, 103.95, 160.65, 201.85, 250.85, 310.55, 343.95]], 
                ['for', 155.4, [3.25, 54.65, 106.2]],
                ['friends', 336.9, [3.25, 54.9, 109.65, 142.1, 179.95, 248.6, 307.4]], 
                ['from', 247.55, [3.25, 54.9, 109.6, 163.1]], 
                ['fun', 171.9, [3.25, 57.15, 112.8]],
                ['gave', 198.2, [3.25, 59.8, 118.15, 170.65]], 
                ['get', 127.85, [3.25, 60.3, 98.35]],
                ['go', 107.65, [3.25, 60.35]], 
                ['going', 251, [3.25, 60.35, 114.7, 145.4, 205.35]], 
                ['good', 199.1, [3.3, 60.4, 106.7, 150.45]], 
                ['got', 145.55, [3.25, 60.35, 116.05]], 
                ['had', 171.55, [3.2, 63.6, 122.8]],
                ['he', 87.7, [3.25, 60.15]], 
                ['her', 152.25, [3.25, 65.15, 103.05]], 
                ['his', 127.25, [3.25, 64.25, 97.75]], 
                ['home', 239.75, [3.25, 64.2, 117.7, 212.2]], 
                ['house', 230.35, [3.25, 61.2, 111, 165.5, 202.8]], 
                ['if', 89, [3.25, 37.05]], 
                ['in', 95.05, [3.25, 35.95]], 
                ['inside', 260.8, [3.25, 32.95, 98.2, 139.6, 172.55, 233.25]], 
                ['into', 186.45, [3.25, 35.95, 101.55, 139.15]], 
                ['is', 61.3, [3.3, 31.85]], 
                ['it', 61.65, [3.25, 32.15]], 
                ['jet', 123.8, [3.25, 60.25, 94.3], true], 
                ['jump', 269.25, [3.25, 64.8, 123.45, 210.2]], 
                ['jumped', 366.1, [3.25, 64.8, 120.45, 207.2, 278.3, 317.4], true], 
                ['jumper', 369.4, [3.25, 64.8, 121.45, 208.2, 279.3, 320.2], true], 
                ['jumps', 304.9, [3.25, 64.8, 123.45, 210.2, 275.4], true], 
                ['just', 185.55, [3.25, 64.8, 119.3, 156.05]], 
                ['keep', 187.35, [3.25, 63.85, 100.45, 128.3], true], 
                ['kind', 215, [3.25, 65.9, 96.7, 166.3]],
                ['kite', 158.95, [3.25, 65.95, 94.85, 131.4], true], 
                ['kitten', 274.35, [3.25, 65.95, 97.85, 135.85, 177.4, 215.25], true], 
                ['know', 257, [3.25, 65.1, 132.3, 182.2]], 
                ['like', 155.25, [3.25, 36.75, 69.1, 127.7]], 
                ['liked', 217.5, [3.25, 36.75, 69.1, 130.7, 168.8]], 
                ['little', 199.15, [3.25, 36.75, 65.65, 101.65, 142.2, 171.6]],
                ['lived', 211.15, [3.25, 37.75, 71.85, 124.35, 162.45]],
                ['lots', 153.55, [3.25, 33.7, 88.4, 124.05]], 
                ['love', 158.65, [3.3, 33.8, 83.7, 131.15]], 
                ['made', 244.7, [3.25, 98.25, 157.45, 217.15]], 
                ['man', 212.3, [3.3, 98.3, 153.25]],
                ['me', 122.3, [3.25, 94.75]], 
                ['morning', 415.8, [3.25, 97.8, 151.35, 209.25, 279.5, 310.2, 370.15]], 
                ['mum', 242.4, [3.25, 99.3, 157.95]],
                ['my', 134.8, [3.25, 89.15]], 
                ['name', 251.9, [3.25, 72.9, 127.85, 224.35]], 
                ['named', 309.15, [3.25, 72.9, 127.85, 222.35, 260.45]],
                ['next', 209.35, [3.3, 74.45, 110.35, 179.9]], 
                ['night', 243.55, [3.25, 73.5, 97.75, 154.7, 214.05]],
                ['no', 117.75, [3.25, 70.45]], 
                ['not', 154.65, [3.25, 70.45, 125.15]],
                ['of', 106.8, [3.3, 54.9]], 
                ['on', 116.85, [3.35, 57.85]], 
                ['once', 194.95, [3.3, 55.8, 126.6, 167.45]],
                ['one', 153.45, [3.35, 54.85, 126]],
                ['our', 160.95, [3.35, 53.15, 111.85]],
                ['out', 137.4, [3.4, 53.2, 108.05]],
                ['park', 235.95, [3.3, 72.9, 128.9, 184.45]],
                ['party', 262.55, [3.3, 72.9, 127.9, 186, 216.95]], 
                ['people', 272.55, [3.35, 69.45, 105.1, 145.6, 215.7, 245.1]],
                ['play', 202, [3.3, 73.4, 106.3, 156.4]], 
                ['played', 299.2, [3.3, 73.4, 106.3, 156.4, 212.45, 250.55]],
                ['put', 158.25, [3.3, 73.95, 128.8]],
                ['queen', 242.4, [3.3, 55.5, 110.9, 145.5, 183.35]], 
                ['quick', 234.35, [3.25, 55.45, 114.95, 144.05, 182.8], true], 
                ['quiet', 207.95, [3.3, 55.5, 115, 144.45, 178.5], true], 
                ['rabbit', 274.9, [3.3, 52.45, 112.8, 164.95, 216.55, 245.45]], 
                ['ran', 170.45, [3.3, 52.4, 111.4]],
                ['really', 259.55, [3.3, 58.95, 97.05, 156.75, 190.15, 213.95]],
                ['red', 145.7, [3.3, 58.95, 97.05]],
                ['ride', 178.2, [3.3, 58.05, 91, 150.7]], 
                ['room', 248.2, [3.3, 58, 109.3, 163.8]], 
                ['said', 181.5, [3.3, 40.1, 99.9, 132.85]], 
                ['saw', 174.2, [3.3, 39.1, 99.45]], 
                ['she', 127.9, [3.3, 43.5, 100.4]],
                ['six', 133.55, [3.3, 44.7, 75.45], true], 
                ['so', 88.9, [3.3, 41.65]], 
                ['some', 216.15, [3.3, 41.65, 94.15, 188.65]], 
                ['sunday', 347.35, [3.25, 67.15, 122.8, 192.45, 251.65, 301.7]], 
                ['the', 127.15, [3.25, 42.7, 99.6]],
                ['then', 196.55, [3.25, 42.7, 99.6, 137.45]],
                ['there', 223.7, [3.25, 42.7, 102.6, 140.5, 196.15]],
                ['they', 174.25, [3.3, 42.75, 99.65, 128.65]],
                ['time', 195.65, [3.25, 43.9, 76.6, 168.1]],
                ['to', 88.15, [3.25, 40.85]], 
                ['under', 277.4, [3.25, 58.95, 129.6, 190.3, 228.2]], 
                ['until', 223.95, [3.3, 61.95, 127.55, 168.2, 201.65]], 
                ['up', 113, [3.25, 53.95]], 
                ['upon', 236.7, [3.25, 53.95, 124.1, 177.6]],
                ['us', 87.3, [3.25, 57.8]], 
                ['very', 190.35, [3.35, 56.85, 94.75, 144.8]], 
                ['was', 170.6, [3.3, 83.35, 141.15]],
                ['we', 112.35, [3.3, 84.85]], 
                ['went', 219.75, [3.3, 84.85, 122.7, 190.3]],
                ['were', 203.9, [3.3, 84.85, 122.75, 176.4]], 
                ['when', 235.55, [3.3, 81.75, 138.65, 176.5]], 
                ['with', 201.1, [3.3, 82.95, 111.85, 151.3]], 
                ['yellow', 286.45, [3.3, 59.35, 97.95, 131.35, 161.8, 211.7], true], 
                ['yes', 122.5, [3.3, 59.35, 93.05]], 
                ['yesterday', 403.3, [3.3, 59.35, 93.05, 129.8, 166.35, 204.25, 253.4, 307.6, 357.7]],
                ['yet', 122.85, [3.3, 59.35, 93.4], true], 
                ['you', 158.45, [3.3, 60.4, 110.2]],
                ['your', 218.05, [3.3, 60.4, 110.15, 168.9]], 
                ['zebra', 239.75, [3.3, 51.9, 91.15, 141.95, 191.1], true], 
                ['zip', 139.75, [3.3, 56, 80.75], true], 
                ['zoo', 146.5, [3.25, 52.9, 99.2], true]
            ];

    for (let i = 0; i < array.length; i++) {
        if (word === array[i][0]) {
            spacing = array[i];
            break;
        }
    }

    return spacing;        
}

export function shadowSize() {
    let containerW = $('#container').width();

    if (containerW > 1400) {
        $('.panel, .header-btn, .nav-btn, .before-btn').addClass('xl');
        $('.panel, .header-btn, .nav-btn, .before-btn').removeClass('lg');
    } else if (containerW > 1000 && containerW < 1400) {
        $('.panel, .header-btn, .nav-btn, .before-btn').addClass('lg');
        $('.panel, .header-btn, .nav-btn, .before-btn').removeClass('xl');
    } else {
        $('.panel, .header-btn, .nav-btn, .before-btn').removeClass('xl');
        $('.panel, .header-btn, .nav-btn, .before-btn').removeClass('lg');
    }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js